import { PlayerService } from "./PlayerService";

export type SuspectState = { suspectIndex: number; boolean: boolean };
export type UpdateStrikeArrayResponse = { string: string };
export class SuspectListService {
    private readonly _playerService: PlayerService = new PlayerService();

    public async updateStrikeArray(index: number, boolean: boolean): Promise<UpdateStrikeArrayResponse> {
        const suspectObject: SuspectState = {
            suspectIndex: index,
            boolean: boolean,
        };
        const data: UpdateStrikeArrayResponse = await fetch(`${VITE_API_URL}suspectlist/strike/${JSON.stringify(suspectObject)}`, {
            headers: {
                "X-PlayerSessionId": this._playerService.getPlayerSessionId(),
            },
        }).then(res => res.json() as Promise<UpdateStrikeArrayResponse>);
        return data;
    }
}
